// components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children }) => {
  const [allowed, setAllowed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!isLoggedIn) {
      toast.warn("Access denied. Kindly log in first.");
      navigate("/login-impact", { replace: true });
    } else {
      setAllowed(true);
    }
  }, [navigate]);

  return allowed ? children : null;
};

export default ProtectedRoute;
